import { Link } from 'react-router-dom';
import { Comment } from '@mui/icons-material';
import { Box, IconButton, Tooltip } from '@mui/material';
import { ListDataItem } from '/src/lib/types';

export type ListCellProps = Partial<ListDataItem>;

export const ListCell: React.FC<ListCellProps> = ({
  flex = 1,
  textAlign,
  content,
  url,
  linkTarget,
  icon,
  isNotes,
  isButton,
  tooltip,
  hide,
  hideOverflow,
  showNotesPopup,
  placeholder = '',
  className = '',
  onClick,
}) => {
  /** Computed **/
  const value = content ?? placeholder;

  /** Render **/
  const renderNotes = () => (
    <IconButton onClick={() => showNotesPopup?.()} className="pointer">
      <Tooltip title="Click to see Notes">
        <Comment className="md-icon material-icons" />
      </Tooltip>
    </IconButton>
  );

  const renderIconButton = () => (
    <Tooltip title={tooltip ?? ''}>
      <IconButton onClick={onClick}>{icon}</IconButton>
    </Tooltip>
  );

  const renderLink = () => (
    <Link to={url ?? ''} target={linkTarget}>
      {value}
    </Link>
  );

  const renderIcon = () => (
    <Box display="flex" gap="6px">
      {icon} {content}
    </Box>
  );

  const renderContent = () => {
    if (isNotes) return renderNotes();
    else if (isButton && icon) return renderIconButton();
    else if (url) return renderLink();
    else if (icon) return renderIcon();
    else return value;
  };

  return (
    <Box
      display="flex"
      flex={flex}
      justifyContent={textAlign === 'left' ? 'start' : textAlign === 'right' ? 'end' : textAlign}
      alignItems="center"
      className={`${textAlign ? `text-${textAlign}` : ''} ${className}`}
      maxWidth={flex && flex > 1 ? flex + '%' : undefined}
      overflow={hideOverflow ? 'hidden' : undefined}
      textOverflow={hideOverflow ? 'ellipsis' : undefined}
      width="100%"
    >
      {!hide && renderContent()}{' '}
    </Box>
  );
};
